import { openAddToExistingModal } from '../State/addToExistingModal'

export default () => (dispatch) => {

  dispatch(openAddToExistingModal())

}
